import { EMPTY_STRING } from '../../../NonReact/constants/Common'

export const DATA_URL_PREFIX: string = 'data:'
export const FILE_SIZE_DENOMINATIONS: string[] = ['B', 'KB', 'MB', 'GB', 'TB']
export const BYTE_DENOMINATION_ROLLOVER_SIZE: number = 1000

/**
 * Converts bytes to the closest unit denomination.
 *
 * @param bytes - The number of bytes to convert.
 */
export const convertBytesToClosestUnit = (bytes: number): string => {
    const [result, unit]: [number, Nullable<string>] = Array.from(
        { length: FILE_SIZE_DENOMINATIONS.length },
        (_: unknown, index: number): number => index
    ).reduce(
        ([accum, currentUnit]: [number, Nullable<string>], i: number): [number, Nullable<string>] => {
            if (accum >= BYTE_DENOMINATION_ROLLOVER_SIZE) {
                const nextUnitIndex: number = i + 1
                const nextUnit: string =
                    nextUnitIndex < FILE_SIZE_DENOMINATIONS.length
                        ? FILE_SIZE_DENOMINATIONS[nextUnitIndex]
                        : FILE_SIZE_DENOMINATIONS[FILE_SIZE_DENOMINATIONS.length - 1]

                return [accum / BYTE_DENOMINATION_ROLLOVER_SIZE, nextUnit]
            }

            return [accum, currentUnit]
        },
        [bytes, EMPTY_STRING]
    )

    return `${result.toFixed(2)}${unit}`
}

/**
 * Convert a file to data uri.
 */
export const fileToDataUri = (file: File): Promise<string> =>
    new Promise((resolve: (value: string) => void, reject: (reason: unknown) => void): void => {
        const reader: FileReader = new FileReader()

        reader.onload = (): void => {
            resolve(reader.result as string)
        }

        reader.onerror = (error: ProgressEvent<FileReader>): void => {
            reject(error)
        }

        reader.readAsDataURL(file)
    })

/**
 * Convert a data uri to a file.
 */
export const dataUriToFile = (dataUri: string, fileName: string): File => {
    const byteString: string = atob(dataUri.split(',')[1])
    const mimeString: string = dataUri.split(',')[0].split(':')[1].split(';')[0]
    const ab: ArrayBuffer = new ArrayBuffer(byteString.length)
    const ia: Uint8Array = new Uint8Array(ab)

    for (let i: number = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    return new File([ab], fileName, { type: mimeString })
}
